import React, { useReducer } from 'react';
import Container from '@material-ui/core/Container';

import SentenVisitor from '../components/sentenVisitor/index';
import Dialog from '../components/dialog/entryData';
import './index.scss';

import { SentenProvider } from '../context';
import { sessionGet } from '../components/worker/worker';
// import Test from '../components/sentenVisitor/test';


const reducer = (s, a) => a;

const initName = () => {
  const n = sessionGet('cosName');
  return !n || n === 'undefined' ? undefined : n;
};

const initBirth = () => {
  const b = sessionGet('birthDate');
  return !b || b === 'undefined' ? undefined : b;
};

const IndexPage = () => {
  const [cosName, cosNameDispatch] = useReducer(reducer, initName());
  const [birthDate, birthDateDispatch] = useReducer(reducer, initBirth());
  const [onDialog, onDialogDispatch] = useReducer(reducer, !initBirth());
  // console.log('onDialog', onDialog);
  // console.log('cosName', cosName);
  // console.log('birthDate', birthDate);


  return (
    <SentenProvider
      value={{
        cosName,
        birthDate,
        onDialog,
        cosNameDispatch,
        birthDateDispatch,
        onDialogDispatch,
      }}
    >
      <Container maxWidth="md">
        { !onDialog
          ? (
            <SentenVisitor
              cosName={cosName}
              birthDate={birthDate}
            />
          )
          : <Dialog /> }
      </Container>
    </SentenProvider>
  );
};


export default IndexPage;

// dialog={Dialog({ cosNameDispatch, birthDateDispatch })}
// { birthDate ? <p>{birthDate}</p> : <Dialog />}
